module.exports = __webpack_public_path__ + "img/coasters.573c3b0e.svg";